import { render, staticRenderFns } from "./CardDocument.vue?vue&type=template&id=e3e0f388&scoped=true&"
import script from "./CardDocument.vue?vue&type=script&lang=ts&"
export * from "./CardDocument.vue?vue&type=script&lang=ts&"
import style0 from "./CardDocument.vue?vue&type=style&index=0&id=e3e0f388&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e0f388",
  null
  
)

export default component.exports